module.exports = __webpack_public_path__ + "4035cb8c6dea1c1a928098ac5fc4908d.png";